import type { IncomingMessage, ServerResponse } from 'http';

import ServerCookies from 'cookies';

export function isUserConnected(
    request: IncomingMessage,
    response: ServerResponse<IncomingMessage>,
) {
    const cookies = new ServerCookies(request, response as ServerResponse<IncomingMessage>);

    return Boolean(cookies.get('evaneos_auth_token'));
}
